<template>
    <section class="hero is-fullheight">

        <div id="context_bar"></div>

        <titlePage>
            <template slot="titleBody">
                <h1 class="page-title title is-size-3">{{ $t('modules.auth.unautorized.title') }}</h1>
            </template>
        </titlePage>

        <div id="index_positions_content" class="hero flex">
            <div class="hero-body flex_content">

                <div class="container micro-container has-text-centered ">

                    <div class="pack_info_bloc">
                        <div v-if="uAccess.contract.subscription_plan == 'start'">
                            <h3 class="page-title subtitle is-size-5">{{ $t('modules.auth.unautorized.start_error_title') }}</h3>
                            <div>{{ $t('modules.auth.unautorized.start_evals_remaining') }} : <strong>{{ uAccess.licence.evaluations_remaining }}</strong></div>
                            <div>{{ $t('modules.auth.unautorized.start_limit_date') }} : <strong>{{ endContractDate }}</strong></div>
                        </div>
                        <div v-if="uAccess.contract.subscription_plan == 'success'">
                            <h3 class="page-title subtitle is-size-5">{{ $t('modules.auth.unautorized.success_error_title') }}</h3>
                        </div>
                        <div v-if="uAccess.contract.subscription_plan == 'custom'">
                            <h3 class="page-title subtitle is-size-5">{{ $t('modules.auth.unautorized.custom_error_title') }}</h3>
                        </div>
                    </div>

                    <div class="pack_active_bloc">
                        <div v-if="!uAccess.active_licence_and_contract">
                            <div v-if="uAccess.contract.subscription_plan == 'start'">
                                <p>{{ $t('modules.auth.unautorized.start_pack_expired') }}</p>
                                <p>{{ $t('modules.auth.unautorized.start_pack_expired_propal') }}</p>
                            </div>
                            <div v-if="uAccess.contract.subscription_plan == 'success'">
                                <p>{{ $t('modules.auth.unautorized.success_pack_not_allowed') }}</p>
                                <p>{{ $t('modules.auth.unautorized.success_pack_propal') }}</p>
                            </div>
                            <div v-if="uAccess.contract.subscription_plan == 'custom'">
                                <p>{{ $t('modules.auth.unautorized.custom_pack_expired') }}</p>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="container mini-container" v-if="uAccess.contract.subscription_plan != 'custom'">
                    <div class="payment_mode">
                        <div class="payment_mode_label" :class="{active: !monthPrice}">
                            {{ $t('modules.auth.unautorized.year_payment') }}
                        </div>
                        <SwitchInput switchId="email_custom_enabled"
                            switchLabel=""
                            :value="monthPrice"
                            @change="handleSwitch" />
                        <div class="payment_mode_label" :class="{active: monthPrice}">
                            {{ $t('modules.auth.unautorized.month_payment') }}
                        </div>
                    </div>

                    <div class="princing_tables">


                        <div class="pricing_bloc success_bloc" v-if="uAccess.contract.subscription_plan == 'start'">
                            <div class="pricing_bloc_title">
                                <h3>{{ $t('modules.auth.unautorized.success_pricing.title') }}</h3>
                                <h4>{{ $t('modules.auth.unautorized.success_pricing.subtitle') }}</h4>
                                <div class="price_container"><span class="price">{{ successPrice }}€</span>/mois</div>
                                <a :href="success_link" target="_blank" class="button is-info is-rounded is-outlined">{{ $t('modules.auth.unautorized.success_pricing.success_button') }}</a>
                            </div>
                            <ul>
                                <li class="price_item"><i class="zmdi zmdi-check"></i><span v-html="$t('modules.auth.unautorized.success_pricing.item1')"></span></li>
                                <li class="price_item"><i class="zmdi zmdi-check"></i><span v-html="$t('modules.auth.unautorized.success_pricing.item2')"></span></li>
                                <li class="price_item"><i class="zmdi zmdi-check"></i><span v-html="$t('modules.auth.unautorized.success_pricing.item3')"></span></li>
                                <li class="price_item"><i class="zmdi zmdi-check"></i><span v-html="$t('modules.auth.unautorized.success_pricing.item4')"></span></li>
                                <li class="price_item"><i class="zmdi zmdi-check"></i><span v-html="$t('modules.auth.unautorized.success_pricing.item5')"></span></li>
                                <li class="price_item"><i class="zmdi zmdi-check"></i><span v-html="$t('modules.auth.unautorized.success_pricing.item6')"></span></li>
                                <li class="price_item"><i class="zmdi zmdi-check"></i><span v-html="$t('modules.auth.unautorized.success_pricing.item7')"></span></li>
                            </ul>
                        </div>

                        <div class="pricing_bloc custom_bloc" >
                            <div class="pricing_bloc_title">
                                <h3>{{ $t('modules.auth.unautorized.custom_pricing.title') }}</h3>
                                <h4>{{ $t('modules.auth.unautorized.custom_pricing.subtitle') }}</h4>
                                <div class="price_container"><span class="price">{{ customPrice }}€</span>/mois</div>
                                <a :href="customLink" target="_blank" class="button is-info is-rounded is-outlined">{{ $t('modules.auth.unautorized.custom_pricing.custom_button') }}</a>
                            </div>
                            <ul>

                                <li class="custom_all_items">{{ $t('modules.auth.unautorized.custom_pricing.all_success_items') }}</li>
                                <li class="custom_all_items_plus">+</li>
                                <li class="price_item"><i class="zmdi zmdi-check"></i><span v-html="$t('modules.auth.unautorized.custom_pricing.item1')"></span></li>
                                <li class="price_item"><i class="zmdi zmdi-check"></i><span v-html="$t('modules.auth.unautorized.custom_pricing.item2')"></span></li>
                                <li class="price_item"><i class="zmdi zmdi-check"></i><span v-html="$t('modules.auth.unautorized.custom_pricing.item3')"></span></li>
                                <li class="price_item"><i class="zmdi zmdi-check"></i><span v-html="$t('modules.auth.unautorized.custom_pricing.item4')"></span></li>
                                <li class="price_item"><i class="zmdi zmdi-check"></i><span v-html="$t('modules.auth.unautorized.custom_pricing.item5')"></span></li>

                            </ul>
                        </div>

                    </div>

                </div>


            </div>
        </div>

    </section>
</template>

<script>
import TitlePage from "@/components/layouts/titlePage"

export default {
    name: 'Unautorized',
    components: {
        TitlePage
    },
    mounted(){
        console.log(this.uAccess)

    },
    data(){
        return {
            monthPrice: false,
            uAccess: JSON.parse(localStorage.getItem('account'))
        }
    },
    computed: {
        startContractDate(){
            return this.$date(this.uAccess.contract.start_date, "YYYY-MM-DD HH:mm:ss").locale(this.$i18n.locale).format('DD/MM/YYYY')
        },
        endContractDate(){
            return this.$date(this.uAccess.contract.end_date, "YYYY-MM-DD HH:mm:ss").locale(this.$i18n.locale).format('DD/MM/YYYY')
        },
        customPrice(){
            return (this.monthPrice) ? 290 : 250
        },
        successPrice(){
            return (this.monthPrice) ? 240 : 200
        },
        success_link(){
            if (this.monthPrice){
                return process.env.VUE_APP_AXIOS_BASE_URL + "shop/update_account/new?access_pack=success_pack&payment_type=month&user_id=" + this.uAccess.user.id + "&company_id=" + this.uAccess.user.company_id
            }else{
                return process.env.VUE_APP_AXIOS_BASE_URL + "shop/update_account/new?access_pack=success_pack&payment_type=year&user_id=" + this.uAccess.user.id + "&company_id=" + this.uAccess.user.company_id
            }
        },
        customLink(){
            return "https://meetings.hubspot.com/aurelie-simois/demo-selection"
        }
    },
    methods: {
        handleSwitch(){
            this.monthPrice = !this.monthPrice
        }
    }
}

</script>

<style lang="scss">
.pack_info_bloc{
    padding-bottom: 15px;
    margin-bottom: 15px;
    border-bottom: 1px solid #ddd;
}
.pack_active_bloc{
    p{
        margin-bottom: 12px;
    }
    padding-bottom: 15px;
    margin-bottom: 50px;
    border-bottom: 1px solid #ddd;
}
.payment_mode{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
    .payment_mode_label{
        font-weight: 400;
        &.active{
            color: $info;
            font-weight: 500;
        }
    }
    .field{
        margin: 0!important;
        margin-left: 8px!important;
        margin-right: 8px!important;
        .switch[type="checkbox"].is-success:checked+label::before, .switch[type="checkbox"].is-success:checked+label:before {
            background: $info;
        }
    }

}
.princing_tables{
    display: flex;
    justify-content: space-evenly;
    align-items: stretch;
    .pricing_bloc{
        max-width: 350px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        text-align: center;
        padding: 20px;
        border: 1px solid #ddd;
        border-radius: 20px;
        .pricing_bloc_title{
            h3{
                color: #000;
                font-weight: 700;
                font-size: 23px;
            }
            h4{
                color: #999999;
                font-family: "Poppins", Sans-serif;
                font-size: 14px;
                font-weight: 500;
                margin-bottom: 10px;
            }
            .price_container{
                margin-bottom: 10px;
                .price{
                    font-size: 40px;
                    font-weight: 600;
                    color: $info;
                }
            }
        }
        ul{
            margin-top: 30px;
            li.custom_all_items{
                color: $info;
                font-family: "Poppins", Sans-serif;
                font-size: 16px;
                font-weight: 500;
                line-height: 1.2em;
                text-align: center;
            }
            li.custom_all_items_plus{
                color: $info;
                font-family: "Poppins", Sans-serif;
                font-size: 22px;
                font-weight: 500;
                line-height: 1.2em;
                text-align: center;
            }
            li.price_item{
                display: flex;
                flex-direction: row;;
                margin-top: 12px;
                color: #555555;
                padding-bottom: calc(21px/2);
                border-bottom: 1px solid #ddd;
                i{
                    color: $info;
                    font-size: 22px;
                    margin-right: 12px;
                }
                &:last-child{
                    border-bottom: none;
                }
            }
            text-align: left;
        }
    }
}

.trial_icon{
    svg{
        width: 100px;
        fill: $danger;
    }
}
</style>
